import { render, staticRenderFns } from "./HomeSelectionInitialMessageModal.vue?vue&type=template&id=12f19d7b&"
import script from "./HomeSelectionInitialMessageModal.vue?vue&type=script&lang=js&"
export * from "./HomeSelectionInitialMessageModal.vue?vue&type=script&lang=js&"
import style0 from "./HomeSelectionInitialMessageModal.vue?vue&type=style&index=0&id=12f19d7b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports